module.exports = __webpack_public_path__ + "7d6f3c7d23fd482440047d7255dca0f0.png";